module.exports = __webpack_public_path__ + "static/media/icon_add.341281a8.svg";